import React from 'react';
import { useLocation } from 'react-router-dom';
import RouteChangeTracker from './RouteChangeTracker';

const RouteChangeTrackerWrapper = () => {
    const location = useLocation();
    return <RouteChangeTracker location={location} />;
};

export default RouteChangeTrackerWrapper;